import React from "react";
import { getClassName } from "@utils";
import { AnalysisItem } from "../AnalysisItem";
import css from "./SentimentAnalysis.module.scss";
import { getRangeMarkerStyles } from "./utils";
import { InfoLabel } from "../InfoLabel";

export interface SentimentAnalysisProps {
  isLoading: boolean;
  value: number | null;
  name?: string;
}

const SentimentAnalysis: React.FC<SentimentAnalysisProps> = ({ isLoading, value, name }) => {
  const rangeMarkerStyles = getRangeMarkerStyles(value);

  const attrs = {
    analysisItem: {
      isLoading,
      title: name ? `${name}'s sentiment` : "Sentiment",
      tooltip: "Analyzes the pragmatic emotional attitude expressed in the message.",
    },
    container: {
      className: getClassName(css.container, isLoading && css.containerLoading),
    },
    text: {
      className: css.text,
    },
    infoLabel: {
      text: "No data to display yet",
      tooltip: "Sentiment cannot be determined yet",
    },
    rangeWrapper: {
      className: css.rangeWrapper,
    },
    range: {
      className: css.range,
    },
    rangeMarker: {
      className: css.rangeMarker,
      style: rangeMarkerStyles,
    },
    rangeDivider: {
      className: css.rangeDivider,
    },
  };

  if (isLoading) {
    return (
      <AnalysisItem {...attrs.analysisItem}>
        <div {...attrs.container}>
          <div {...attrs.text}>
            <span>Negative</span>
            <span>Positive</span>
          </div>
          <div {...attrs.rangeWrapper}>
            <div {...attrs.range} />
          </div>
        </div>
      </AnalysisItem>
    );
  }

  return (
    <AnalysisItem {...attrs.analysisItem}>
      <div {...attrs.container}>
        <div {...attrs.text}>
          <span>Negative</span>
          <span>Positive</span>
        </div>
        {value !== null ? (
          <div {...attrs.rangeWrapper}>
            <div {...attrs.range}>
              <div {...attrs.rangeDivider} />
              <div {...attrs.rangeMarker} />
            </div>
          </div>
        ) : (
          <InfoLabel {...attrs.infoLabel} />
        )}
      </div>
    </AnalysisItem>
  );
};

export default SentimentAnalysis;
